import * as React from "react";
import CustomFieldsView from "./CustomFieldsView";
import CustomField from "../../../model/customField/CustomField";
import {Dispatch} from "redux";
import {createJobCustomField, fetchJobCustomFields, updateJobCustomField} from "../../../store/action/customField/customField";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {RootState} from "../../../store/reducer/root/RootState";
import {Option} from "ts-option";
import {connect} from "react-redux";
import {OnFailure, OnSuccess, OnSuccessData} from "../../../store/action/actionHelpers";
import Toast from "../../helper/Toast";

interface IDispatchProps {
	/**
	 * Fetch job custom fields method
	 */
	fetchJobCustomFields: () => void;
	/**
	 * Create job custom field.
	 * @param {CustomField} customField
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createJobCustomField: (customField: CustomField, onSuccess: OnSuccessData<CustomField>, onFailure: OnFailure) => void;
	/**
	 * Update job custom field.
	 * @param {CustomField} customField
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateJobCustomField: (customField: CustomField, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface ReduxProps {
	/**
	 * Job custom fields list.
	 */
	jobCustomFields: Option<CustomField[]>;
}

type Props = IDispatchProps & ReduxProps;

class JobCustomFieldsView extends React.Component<Props> {
	render() {
		return (
			<CustomFieldsView customFields={this.props.jobCustomFields}
							  fetchCustomFields={this.props.fetchJobCustomFields}
							  createCustomField={this.createJobCustomField}
							  updateCustomField={this.updateJobCustomField}
							  pageTitle={'Job custom fields'}
							  noDataText={'No job custom fields'}/>
		);
	}

	createJobCustomField = (customField: CustomField,
		onSuccess: OnSuccessData<CustomField>,
		onFailure: OnFailure) =>
		this.props.createJobCustomField(customField,
			(customField) => {
				onSuccess(customField);
				Toast.success("Job custom field created", "Job custom field create");
			},
			(err) => {
				onFailure(err);
				notifyBugsnagAndShowToast(err, "Job custom field creation failed");
			}
		);

	updateJobCustomField = (customField: CustomField,
		onSuccess: OnSuccess,
		onFailure: OnFailure) =>
		this.props.updateJobCustomField(customField,
			() => {
				onSuccess();
				Toast.success("Job custom field updated", "Job custom field update");
			},
			(err) => {
				onFailure(err);
				notifyBugsnagAndShowToast(err, "Job custom field update failed");
			}
		);
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchJobCustomFields: () => dispatch(
			fetchJobCustomFields(() => {}, (error) => notifyBugsnagAndShowToast(error, "Fetch job custom fields"))
		),
		createJobCustomField: (customField: CustomField, onSuccess: OnSuccessData<CustomField>, onFailure: OnFailure) => {
			dispatch(createJobCustomField(customField, onSuccess, onFailure))
		},
		updateJobCustomField: (customField: CustomField, onSuccess: OnSuccess, onFailure: OnFailure) => {
			dispatch(updateJobCustomField(customField, onSuccess, onFailure))
		}
	};
}

function mapStateToProps(state: RootState) {
	return {
		jobCustomFields: state.customFields.jobCustomFields,
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(JobCustomFieldsView)